import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { getBasePath } from "@/lib/utils";

const NotFound = () => {
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const basePath = getBasePath(loggedInUserData?.role);

  return (
    <div className="flex items-center justify-center h-screen bg-primary-700">
      <div className="text-center text-white">
        <h1 className="text-[60px] font-bold">404</h1>
        <p className="text-[17px] mt-4">Oops, Page Not Found</p>
        <Link
          to={basePath}
          className="mt-6 inline-block px-6 py-2 text-primary-700 bg-white font-semibold rounded-lg shadow-md hover:bg-gray-200"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
